import { A9Service, adapter, IDataProviderV2, Service } from 'components/system';

@A9Service('customerAllContactsNotDataProvider')
export class CustomerAllContactsNotDataProvider extends Service {
    private readonly services: { [key: string]: IDataProviderV2 };

    constructor($injector: angular.auto.IInjectorService) {
        super();
        this.services = {
            phone: $injector.get('customerPhoneDataProvider'),
            email: $injector.get('customerEmailDataProvider'),
            site: $injector.get('customerSiteDataProvider'),
            social: $injector.get('customerSocialDataProvider'),
            ims: $injector.get('customerImDataProvider')
        };
    }

    public getGroupsInformationList() {
        return [
            {
                id: 'phone',
                translationId: 'phone2'
            },
            {
                id: 'email',
                translationId: 'email2'
            },
            {
                id: 'site',
                translationId: 'url'
            },
            {
                id: 'social',
                translationId: 'social'
            },
            {
                id: 'ims',
                translationId: 'im'
            }
        ];
    }

    public getProviderByType(type) {
        return this.services[type];
    }

    public static getItemValueName(type) {
        let name = '';
        switch (type) {
            case 'phone':
                name = 'customer.profile.contactPhone';
                break;
            case 'email':
                name = 'customer.profile.contactEmailAddress';
                break;
            case 'site':
                name = 'customer.profile.contactSite';
                break;
            case 'social':
                name = 'customer.profile.contactSocialMedia';
                break;
            case 'ims':
                name = 'customer.profile.contactInstantMessenger';
                break;
        }
        return name;
    }

    public getItemButtonName(type) {
        let name = '';
        switch (type) {
            case 'phone':
                name = 'customer.contact.makeMainContact';
                break;
            case 'email':
                name = 'customer.contact.makeMainContactAddress';
                break;
            case 'site':
                name = 'customer.contact.makeMainContactSite';
                break;
            case 'social':
                name = 'customer.contact.makeMainContactMedia';
                break;
            case 'ims':
                name = 'customer.contact.makeMainContactMessage';
                break;
        }
        return name;
    }

    public adjustGroupItem(type, item) {
        item.group = type;
        switch (type) {
            case 'phone':
                item.phoneTypeId = item.phoneTypeId;
                item.value = item.phone;
                break;
            case 'email':
                item.type = `email_${item.usageType.toLowerCase()}`;
                item.value = item.email;
                break;
            case 'site':
                item.type = `site_${item.usageType.toLowerCase()}`;
                item.value = item.site;
                break;
            case 'social':
                item.type = `${item.socialType}`;
                item.value = item.social;
                break;
            case 'ims':
                item.type = `${item.imsType}`;
                item.value = item.ims;
                break;
        }
        return item;
    }

    public listAll(groupId, customerId) {
        return this.services[groupId]
            .all(
                {
                    sorting: [{ field: 'id', direction: 'asc' }]
                },
                {
                    customerId: customerId
                }
            )
            .then(listData => listData);
    }

    public parseAndUpdate(groupId, customerId, data) {
        let promise = Promise.resolve();

        data.forEach(item => {
            if (!item.id) {
                promise = promise
                    .then(() => {
                        return this.add(groupId, customerId, item);
                    })
                    .then(contact => {
                        item.id = contact.id;
                    });
            } else {
                promise = promise.then(() => {
                    return this.update(groupId, customerId, item).then(() => {});
                });
            }
        });

        return promise;
    }

    public add(groupId: string, customerId: string, item) {
        //#21263
        return new Promise<object>(resolve => {
            if (groupId === 'phone' || groupId === 'email') {
                this.listAll(groupId, customerId).then(items => {
                    if (items.length === 0) {
                        if (groupId === 'phone') {
                            item.mainForCall = true;
                            item.mainForSms = true;
                        } else if (groupId === 'email') {
                            item.main = true;
                        }
                    }
                    resolve(item);
                });
            } else {
                resolve(item);
            }
        }).then((item: any) => {
            return this.services[groupId].add(item, {
                customerId: customerId
            });
        });
    }

    public update(groupId, customerId, item) {
        return this.services[groupId].update(item, {
            customerId: customerId,
            id: item.id
        });
    }

    public patch(groupId, customerId, itemId, patch) {
        return this.services[groupId].customPatch(patch, {
            customerId: customerId,
            id: itemId
        });
    }

    public remove(groupId, customerId, item) {
        return this.services[groupId].remove({
            customerId: customerId,
            id: item.id
        });
    }
}
